/* eslint-disable consistent-return */
/* eslint-disable no-useless-escape */
/* eslint-disable require-jsdoc */
const extractTopDomain = (url) => {
  const topDomain = url.match(/^(?:(?:http[s]?|ftp):\/)?\/?(?:[^:\/\s]+?\.)*([^:\/\s]+\.[^:\/\s]+)/)
  if (topDomain) return topDomain[1]
}

export default extractTopDomain
